import api from './api'

export const chartingService = {
  // Obtener datos históricos de velas
  getHistory: (params) => api.get('/charting/history', { params }),

  // Buscar símbolos disponibles
  searchSymbols: (query = '', exchange = 'bingx', source = 'crypto') =>
    api.get('/charting/symbols', { params: { query, exchange, source } }),

  // Obtener configuración del gráfico
  getConfig: () => api.get('/charting/config'),

  // ICT/SMC indicators: FVGs, Order Blocks, CHoCH, BOS, swing structure
  getICT: (params) => api.get('/charting/ict', { params }),

  // Order Blocks Quantum indicator
  getOrderBlocks: (params, options) => api.get('/charting/order-blocks', { params, ...options }),

  // Mitigation Block Quantum indicator
  getMitigationBlocks: (params, options) => api.get('/charting/mitigation-blocks', { params, ...options }),

  // Liquidity Pools Quantum indicator (canon v1.0: solo symbol, resolution,
  // from_time, to_time, source — sin config params, la lógica la fija el canon)
  getLiquidityPools: (params, options) => api.get('/charting/liquidity-pools', { params, ...options }),

  // ICT/SMC trade signal with grade (A+/A-), entry, SL, TP1/2/3
  getICTSignal: (params) => api.get('/charting/ict/signal', { params }),

  // Historical ICT signals with outcomes (TP/SL/OPEN) — cached, CPU-intensive
  getICTSignalsHistory: (params) => api.get('/charting/ict/signals-history', { params }),

  // Internal SMC/ICT indicators from backend core: EMA200, relative volume, FVG BISI/SIBI, CHoCH/BOS
  getInternalIndicators: (params) => api.get('/charting/indicators', { params }),
}
